import React, { Component } from 'react'
import EntryTable from './entryTable.js';
import { Header, Input } from 'semantic-ui-react'
import { connect } from "react-redux";
import { getTodos } from "../redux/selectors";
import GoogleAnalytics from 'react-ga'

class MobileSync extends Component {
  state = {  }

  startSending = () => {
    const values = this.props.entries;
    if(values.length < 1){
      console.log("no data");
      return;
    }

    const content = JSON.stringify({"entries" : values});
    const fileName = `koraccount_${getCurrentDateTime()}.kaim`;
    const contentType = "text/plain";
    const a = document.createElement("a");
    const file = new Blob([content], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
    
    GoogleAnalytics.event({category: 'Sync', action: 'Download' });
    console.log("download data");
  }
  render() {
    const { numberOfEntries } = this.props
    return (
      <div>
{(numberOfEntries > 0) && 
  <div>
        <Header>Laden Sie die Daten herunter und importieren Sie sie in Ihr korAccount.</Header>
        <button onClick={this.startSending} class="ui icon left labeled button blue"><i aria-hidden="true" class="download icon"></i>{this.props.numberOfEntries} Einträge herunterladen</button>
        <br /><br />
       </div> 
      }        
        <EntryTable readOnly="true"></EntryTable>
      </div>
    )
  }
}

const getCurrentDateTime = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-based.
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  // Format: YYYYMMDD_HHMMSS
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};

const mapStateToProps = state => {
  const entries = getTodos(state);
  const numberOfEntries = entries.length;
  return { entries, numberOfEntries };
};

export default connect(mapStateToProps)(MobileSync);